import './_blurb-list.columns.scss';

/**
 * Column layout for BlurbList - displays items in a responsive grid.
 */
export default function BlurbListColumns({ columns = 3, children, className = '' }) {
  if (!children) return null;

  return (
    <div
      className={`BlurbList BlurbList__columns ${className}`}
      style={{
        // @ts-ignore
        '--blurb-list-columns': columns
      }}
    >
      {children}
    </div>
  );
}
